import { TextInput, Textarea, Stack } from "@mantine/core";
import { useForm } from "@mantine/form";
import { Procedure } from "../../../services/admin/procedures.service";
import { required, scrollToFirstError } from "../../../utils/formValidation";

export interface ProcedureFormValues {
  name: string;
  description: string;
}

interface ProcedureFormProps {
  initialValues?: Procedure;
  onSubmit: (values: ProcedureFormValues) => void;
}

export default function ProcedureForm({
  initialValues,
  onSubmit,
}: ProcedureFormProps) {
  const form = useForm<ProcedureFormValues>({
    initialValues: {
      name: initialValues?.name || "",
      description: initialValues?.description || "",
    },
    validate: {
      name: required("Procedure name is required"),
    },
  });

  const handleSubmit = form.onSubmit(
    (values) => onSubmit(values),
    () => scrollToFirstError(form)
  );

  return (
    <form noValidate onSubmit={handleSubmit}>
      <Stack gap="md">
        <TextInput
          label="Procedure Name"
          placeholder="e.g., Colonoscopy, Biopsy, Endoscopy"
          withAsterisk
          {...form.getInputProps("name")}
        />

        <Textarea
          label="Description"
          placeholder="Enter procedure description"
          minRows={3}
          {...form.getInputProps("description")}
        />
      </Stack>
    </form>
  );
}

export { useForm } from "@mantine/form";
